import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row } from 'react-bootstrap';
import InstallerTableContainer from '../Containers/InstallerTableContainer';
import InstallerTestExpectedContainer from '../Containers/InstallerTestExpectedContainer';

const InstallerTestExpectedModalComponent = ({
  visible,
  buildPage,
  onHide
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>Installer Tests Expected Files</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        {
          buildPage ?
            <InstallerTableContainer
              showExpected
            /> :
            <InstallerTestExpectedContainer
              showExpected
              requiresAck={false}
            />
        }
      </Row>
    </Modal.Body>
  </Modal>
);

InstallerTestExpectedModalComponent.propTypes = {
  visible: PropTypes.bool,
  buildPage: PropTypes.bool,
  onHide: PropTypes.func.isRequired
};

export default InstallerTestExpectedModalComponent;


// WEBPACK FOOTER //
// src/Components/InstallerTestExpectedModalComponent.jsx